import React from "react";
import styles from "./Footer.module.css";
import { Activity, currentRequestTimeStamp } from "./../Constants";
import mixpanel from "mixpanel-browser";
import { Urls } from "../../Urls";

const trackUserAction = (screen, module, activity, log, data, definition) => {
  Activity([
    {
      screen,
      module,
      user_activity: activity,
      timestamp: currentRequestTimeStamp(),
    },
  ]);

  mixpanel.track(log, {
    ApplicationName: Urls.mixpanelappname,
    ScreenName: screen,
    ModuleName: module,
    ActivityLog: log,
    Data: data,
    Definition: definition,
    ActivityType: "event_view",
  });
};

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      <div className={``}>
        <div className={styles.centerText}>
          <ul className={styles.linkList}>
            <li className={styles.linkItem}>
              <a
                className={styles.whiteLink}
                href="mailto:lorri@logisticsnow.ai"
                onClick={() =>
                  trackUserAction(
                    "Footer",
                    "Footer-Mail",
                    "Mail clicked",
                    "userClickedMailLinkButton",
                    "lorri@logisticsnow.ai",
                    "User has clicked on mail link button",
                  )
                }
              >
                lorri@logisticsnow.ai
              </a>
            </li>
            <li className={styles.linkItem}>
              <a
                className={styles.whiteLink}
                href="tel:9867773508"
                onClick={() =>
                  trackUserAction(
                    "Footer",
                    "Footer-Contact",
                    "Contact clicked",
                    "userClickedNumber",
                    "9867773508",
                    "User has clicked on number",
                  )
                }
              >
                +91-9867773508
              </a>
            </li>
          </ul>
        </div>

        <div className={styles.centerText}>
          <ul className={styles.linkList}>
            <li className={styles.linkItem}>
              <a
                className={styles.greyLink}
                href={`${Urls.LNTNCUrl}/benchmark_tnc.html`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  trackUserAction(
                    "Footer",
                    "Footer-TnC",
                    "Terms of Use clicked",
                    "userClickedTermsofUse",
                    "None",
                    "User has clicked on Terms of Use",
                  )
                }
              >
                Terms of Use
              </a>
            </li>
            <li className={styles.linkItem}>
              <a
                className={styles.greyLink}
                href={`${Urls.LNTNCUrl}/privacypolicy.html`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  trackUserAction(
                    "Footer",
                    "Footer - Privacy Policy",
                    "Privacy Policy clicked",
                    "userClickedPrivacyPolicy",
                    "None",
                    "User has clicked on Privacy Policy",
                  )
                }
              >
                Privacy Policy
              </a>
            </li>
            <li className={styles.linkItem}>
              <a
                className={styles.greyLink}
                href={`${Urls.LNBaseUrl}/about-us.aspx`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  trackUserAction(
                    "Footer",
                    "Footer - About Us",
                    "About Us clicked",
                    "userClickedAboutus",
                    "None",
                    "User has clicked about us",
                  )
                }
              >
                About Us
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.copyright}>
        <a
          href={Urls.LNBaseUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.whiteLink}
        >
          © LogisticsNow {currentYear} | Managed by <strong>LOGISTICSNOW PRIVATE LIMITED</strong>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
